"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnregistrationToken = void 0;
/**
 * Provides a simple mechanism to un-register from a SimpleDispatcher
 */
var UnregistrationToken = /** @class */ (function () {
    /**
     * @constructor
     * @param unRegistrationCallback the unregistration logic to execute on unsubscribe (probably 'private' to your service)
     */
    function UnregistrationToken(unRegistrationCallback) {
        var _this = this;
        this.unRegistrationCallback = unRegistrationCallback;
        /**
         * Main (only) method, executes the unsubscription method.
         */
        this.unregister = function () { return _this.unRegistrationCallback(); };
    }
    return UnregistrationToken;
}());
exports.UnregistrationToken = UnregistrationToken;
